export function isItemInLocalStorage(key) {
  return localStorage.getItem(key) !== null;
}

export function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}
